import React from 'react';
export const CmsTextsContext = React.createContext([
    {
        status: 'not_loaded',
        texts: undefined,
    },
    () => {
        // Will be set by the provider.
    },
]);
